import { render } from "./Registration.vue?vue&type=template&id=52731e1a&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=52731e1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52731e1a"]])

export default __exports__